"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var DataCrypt_1 = require("../../models/common/lib/DataCrypt");
var AbilityService_1 = require("../../apiServices/auth/AbilityService");
var FunctionTypeLibrary_1 = require("../../api/FunctionTypeLibrary");
var ExportService_1 = require("../importExportService/ExportService");
var DeepCopy_1 = require("../../models/common/lib/DeepCopy");
var AppSettings_1 = tslib_1.__importDefault(require("../../apiServices/auth/AppSettings"));
var Permissions_1 = require("../../apiServices/rbac/permissions/Permissions");
var lodash_1 = require("lodash");
var SceCompressedModel_1 = require("../../models/SceCompressedModel/SceCompressedModel");
var DataBuilder_1 = require("../../builder/DataBuilder");
var ModelConstants_1 = require("../../constants/ModelConstants");
var SceModel_1 = require("../../models/SceModel");
var EngineeringModel_1 = require("../../api/enggModel/EngineeringModel");
var Field_1 = require("../../constants/Field");
var Helper_1 = require("../Helper");
var FunctionsLibrary = /** @class */ (function () {
    function FunctionsLibrary() {
        this._enggModelApi = new EngineeringModel_1.EngineeringModel();
    }
    FunctionsLibrary.prototype.createLibrary = function (libraryName, libraryPassword, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, libraryInfo, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (withIPProtection && libraryPassword === "") {
                            throw new Error("Password cannot be empty when withIPProtection is true");
                        }
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, libraryPassword === null ? "" : libraryPassword);
                        libraryInfo = {
                            name: libraryName,
                            encryptedPassword: encryptedPassword,
                        };
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.createLibrary(libraryInfo, withIPProtection)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.addFunctionsToNewLibrary = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, libraryInfo, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (withIPProtection && libraryDetails.password === "") {
                            throw new Error("Password cannot be empty when withIPProtection is true");
                        }
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, libraryDetails.password === null ? "" : libraryDetails.password);
                        libraryInfo = {
                            name: libraryDetails.libraryName,
                            encryptedPassword: encryptedPassword,
                            functionTypes: libraryDetails.functions,
                        };
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.addFunctionsToNewLibrary(libraryInfo, withIPProtection)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.addFunctionsToExistingLibrary = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, libraryInfo, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (withIPProtection && libraryDetails.password === "") {
                            throw new Error("Password cannot be empty when withIPProtection is true");
                        }
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, libraryDetails.password === null ? "" : libraryDetails.password);
                        libraryInfo = {
                            libraryId: libraryDetails.libraryId,
                            libraryVersion: libraryDetails.libraryVersion,
                            encryptedPassword: encryptedPassword,
                            functionTypes: libraryDetails.functions,
                        };
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.addFunctionsToExistingLibrary(libraryInfo, withIPProtection)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.removeFunctionsFromExistingLibrary = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, libraryInfo, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, libraryDetails.password === null ? "" : libraryDetails.password);
                        libraryInfo = {
                            libraryId: libraryDetails.libraryId,
                            libraryVersion: libraryDetails.libraryVersion,
                            encryptedPassword: encryptedPassword,
                            functionTypes: libraryDetails.functions,
                        };
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.RemoveFunctionsFromLibrary(libraryInfo, withIPProtection)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.deleteLibrary = function (libraryId, libraryVersion, password, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, password === null ? "" : password);
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.DeleteLibrary(libraryId, libraryVersion, encryptedPassword, withIPProtection)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.deleteLibraryNew = function (libraryId, libraryVersion, password, withIPProtection, deleteFunctions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, password === null ? "" : password);
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.DeleteLibraryNew(libraryId, libraryVersion, encryptedPassword, withIPProtection, deleteFunctions)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.getLibraryAndNodes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.GetLibraryNodes()];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.getMutuallyExclusiveFunctionTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.GetMutuallyExclusiveFunctionTypes()];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.getExportableFunctions = function (exportableInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.GetExportableFunctions(exportableInfo)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.getExportableTypes = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var exportService, modelsClone, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        exportService = new ExportService_1.ExportService();
                        return [4 /*yield*/, exportService.getUniqueModelsWithReferencedTypes(DeepCopy_1.deepCopy(models))];
                    case 1:
                        modelsClone = _a.sent();
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission(); // Functions will be read from Type Reg
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.GetExportableTypes(modelsClone)];
                    case 2:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.importFunctions = function (libraryInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var libraryDecryptPackInfo, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        libraryDecryptPackInfo = [];
                        lodash_1.map(libraryInfo, function (info) {
                            // const encryptedPassword = DataCrypt.encryptPassword(
                            //   AbilityService.accessToken,
                            //   info.password === null ? "" : info.password
                            // );
                            if (info.libraryPack) {
                                var libraryPack = tslib_1.__assign({}, info.libraryPack);
                                if (libraryPack && libraryPack.functionTypes && Array.isArray(libraryPack.functionTypes)) {
                                    var updatedLibraryFunctionTypes = lodash_1.map(libraryPack.functionTypes, function (json) {
                                        var jsonTags = json[Field_1.FIELD.TAGS] ? json[Field_1.FIELD.TAGS] : [];
                                        json[Field_1.FIELD.TYPEID] = Helper_1.Helper.updateTenantSpecificTypeId(json[Field_1.FIELD.TYPEID], jsonTags, false);
                                        json[Field_1.FIELD.TAGS] = Helper_1.Helper.updateTenantSpecificTags(jsonTags);
                                        return json;
                                    });
                                    info.libraryPack.functionTypes = tslib_1.__spreadArrays(updatedLibraryFunctionTypes);
                                }
                            }
                            var libraryDecryptPack = {
                                // encryptedPassword,
                                libraryPack: info.libraryPack
                            };
                            libraryDecryptPackInfo.push(libraryDecryptPack);
                        });
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.ImportFunctionTypes(libraryDecryptPackInfo)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // This method will call importFunctions method internally and the lib logic for this importFunctions method
    // is been moved to API side, once tested with all the scenarios the importFunctions method can be removed
    FunctionsLibrary.prototype.importFunctionsWithLibrary = function (libraryInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.ImportFunctionsWithLibrary(libraryInfo)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.validateLibImport = function (libraryInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var libraryDecryptPackInfo, response, e_1, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("---------ValidateLibImport STARTS------");
                        console.log("libraryInfo payload INCOMING", libraryInfo);
                        libraryDecryptPackInfo = [];
                        lodash_1.map(libraryInfo, function (info) {
                            if (info.libraryPack) {
                                var libraryPack = tslib_1.__assign({}, info.libraryPack);
                                if (libraryPack && libraryPack.functionTypes && Array.isArray(libraryPack.functionTypes)) {
                                    var updatedLibraryFunctionTypes = lodash_1.map(libraryPack.functionTypes, function (json) {
                                        var jsonTags = json[Field_1.FIELD.TAGS] ? json[Field_1.FIELD.TAGS] : [];
                                        json[Field_1.FIELD.TYPEID] = Helper_1.Helper.updateTenantSpecificTypeId(json[Field_1.FIELD.TYPEID], jsonTags, false);
                                        json[Field_1.FIELD.TAGS] = Helper_1.Helper.updateTenantSpecificTags(jsonTags);
                                        return json;
                                    });
                                    info.libraryPack.functionTypes = tslib_1.__spreadArrays(updatedLibraryFunctionTypes);
                                }
                            }
                            var libraryDecryptPack = {
                                // encryptedPassword,
                                libraryPack: info.libraryPack
                            };
                            libraryDecryptPackInfo.push(libraryDecryptPack);
                        });
                        console.log("libraryDecryptPack payload to API", libraryDecryptPackInfo);
                        response = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.ValidateLibImport(libraryDecryptPackInfo)];
                    case 2:
                        response = _a.sent();
                        console.log("ValidateLibImport API response", response);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log("ValidateLibImport API Error ", e_1);
                        throw new Error("Validate library import error");
                    case 4:
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        console.log("result object", result);
                        console.log("---------ValidateLibImport FINISH------");
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // This method will call validateLibImport method internally and the lib logic for this validateLibImport method
    // is been moved to API side, once tested with all the scenarios the validateLibImport method can be removed
    FunctionsLibrary.prototype.validateLibImportWithLibrary = function (libraryInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.ValidateLibImportWithLibrary(libraryInfo)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.importTypes = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var compressedModels, dependentLibraries, compressedZippedModels, response, responseClone, mapPromises, result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        compressedModels = lodash_1.map(models.models, function (sceZippedModel) {
                            var compressedModel = SceCompressedModel_1.SceCompressedModel.createSceCompressedJson([sceZippedModel.model], false);
                            var compressedZippedModel = {
                                compressedModel: compressedModel.toJson(),
                                functionTypes: sceZippedModel.functionTypes,
                                libraryReferences: sceZippedModel.libraryReferences
                            };
                            return compressedZippedModel;
                        });
                        dependentLibraries = lodash_1.map(models.dependentLibraries, function (dependentLibrary) {
                            var encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, dependentLibrary.password === null ? "" : dependentLibrary.password);
                            return {
                                library: dependentLibrary.library,
                                encryptedPassword: encryptedPassword
                            };
                        });
                        compressedZippedModels = {
                            models: compressedModels,
                            dependentLibraries: dependentLibraries
                        };
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.ImportTypes(compressedZippedModels)];
                    case 1:
                        response = _a.sent();
                        responseClone = DeepCopy_1.deepCopy(response);
                        mapPromises = lodash_1.map(response.data.successDetails, function (successDetail, successIndex) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var enggModel, sceModel, mappingModel, error_1, model;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (successDetail.status === 'Failure') {
                                            return [2 /*return*/];
                                        }
                                        if (!(successDetail.dataIn.model === ModelConstants_1.ModelConstants.SceModel)) return [3 /*break*/, 10];
                                        enggModel = lodash_1.find(models.models, function (sceZippedModel) {
                                            var sceModelType = sceZippedModel.model;
                                            return sceModelType.properties.model.typeId.value === successDetail.dataIn.typeId;
                                        });
                                        if (!(enggModel !== undefined)) return [3 /*break*/, 10];
                                        sceModel = SceModel_1.SceModel.fromJson(enggModel.model, false);
                                        return [4 /*yield*/, sceModel.properties.fetchMappings()];
                                    case 1:
                                        mappingModel = _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        _a.trys.push([2, 8, , 10]);
                                        return [4 /*yield*/, sceModel.saveComputeModel()];
                                    case 3:
                                        _a.sent();
                                        mappingModel.properties.addType(successDetail.dataOut[Field_1.FIELD.OBJECTID], "Published", sceModel.properties.model.model.value);
                                        if (!mappingModel.objectId) return [3 /*break*/, 5];
                                        return [4 /*yield*/, mappingModel.updateMappings()];
                                    case 4:
                                        _a.sent();
                                        return [3 /*break*/, 7];
                                    case 5: return [4 /*yield*/, mappingModel.saveMappings()];
                                    case 6:
                                        _a.sent();
                                        _a.label = 7;
                                    case 7:
                                        responseClone.data.successDetails[successIndex].dataOut[Field_1.FIELD.MODEL] = enggModel.model;
                                        responseClone.data.successDetails[successIndex].dataOut[Field_1.FIELD.MODEL][Field_1.FIELD.OBJECTID] = successDetail.dataOut[Field_1.FIELD.OBJECTID];
                                        return [3 /*break*/, 10];
                                    case 8:
                                        error_1 = _a.sent();
                                        model = sceModel.properties.model;
                                        return [4 /*yield*/, this._enggModelApi.DeleteEnggModel(successDetail.dataOut[Field_1.FIELD.OBJECTID], sceModel.model, model.model.value, model.typeId.value)];
                                    case 9:
                                        _a.sent();
                                        successDetail.status = 'Failure';
                                        successDetail.reason = ["Failed to save type definition for type " + model.name.value];
                                        return [3 /*break*/, 10];
                                    case 10: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(mapPromises)];
                    case 2:
                        _a.sent();
                        result = {
                            details: responseClone.data,
                            status: responseClone.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.validateTypeImport = function (models) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var compressedModels, dependentLibraries, compressedZippedModels, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        compressedModels = lodash_1.map(models.models, function (sceZippedModel) {
                            var compressedModel = SceCompressedModel_1.SceCompressedModel.createSceCompressedJson([sceZippedModel.model], false);
                            var compressedZippedModel = {
                                compressedModel: compressedModel.toJson(),
                                functionTypes: sceZippedModel.functionTypes,
                                libraryReferences: sceZippedModel.libraryReferences
                            };
                            return compressedZippedModel;
                        });
                        dependentLibraries = lodash_1.map(models.dependentLibraries, function (dependentLibrary) {
                            var encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, dependentLibrary.password === null ? "" : dependentLibrary.password);
                            return {
                                library: dependentLibrary.library,
                                encryptedPassword: encryptedPassword
                            };
                        });
                        compressedZippedModels = {
                            models: compressedModels,
                            dependentLibraries: dependentLibraries
                        };
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.ValidateTypeImport(compressedZippedModels)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.getDecryptedFunctionType = function (libraryId, libraryVersion, password, functionInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, response, decryptedFunctionType, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, password);
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.GetDecryptedFunctionType(libraryId, libraryVersion, encryptedPassword, functionInfo)];
                    case 1:
                        response = _a.sent();
                        decryptedFunctionType = DataBuilder_1.DataBuilder.buildFunctionType(response.data);
                        result = {
                            details: decryptedFunctionType,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.updateIPProtectedFunction = function (libraryId, libraryVersion, password, functionInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, password);
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.UpdateIPProtectedFunctionType(libraryId, libraryVersion, encryptedPassword, functionInfo)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.getLibraryReferencesForFunctionTypes = function (functionTypes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.GetLibraryReferencedFunctions(functionTypes)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.getFunctionTypeWithEncryptionStatus = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.GetFunctionTypeWithEncryptionStatus(modelId, typeId, version)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: DataBuilder_1.DataBuilder.buildFunctionTypeeWithEncryptionStatus(response.data),
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.getTypeLatestFunctionDataWithEncryption = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.GetTypeLatestFunctionDataWithEncryption(modelId, typeId, version)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: DataBuilder_1.DataBuilder.buildMultipleFunctionTypeeWithEncryptionStatus(response.data),
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.convertToIPProtectedLibrary = function (libraryId, libraryVersion, password) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, password);
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.ConvertToIPProtectedLibrary(libraryId, libraryVersion, encryptedPassword)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.CreateAndAssociateFunctionToLib = function (libraryId, libraryVersion, password, functionTypeDetails) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, password);
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.CreateAndAssociateFunctionToLib(libraryId, libraryVersion, encryptedPassword, functionTypeDetails)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.ChangeLibraryPassword = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, encryptedNewPassword, libraryDataExtended, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (withIPProtection && libraryDetails.password === "") {
                            throw new Error("Password cannot be empty when withIPProtection is true");
                        }
                        if (withIPProtection && libraryDetails.newPassword === "") {
                            throw new Error("New Password cannot be empty.");
                        }
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, libraryDetails.password === null ? "" : libraryDetails.password);
                        encryptedNewPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, libraryDetails.newPassword === null ? "" : libraryDetails.newPassword);
                        libraryDataExtended = {
                            libraryId: libraryDetails.libraryId,
                            libraryVersion: libraryDetails.libraryVersion,
                            encryptedPassword: encryptedPassword,
                            encryptedNewPassword: encryptedNewPassword,
                            functionTypes: libraryDetails.functions,
                        };
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.ChangeLibraryPassword(libraryDataExtended, withIPProtection)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.UnlockLibrary = function (libraryDetails, withIPProtection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, libraryInfo, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (withIPProtection && libraryDetails.password === "") {
                            throw new Error("Password cannot be empty when withIPProtection is true");
                        }
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, libraryDetails.password === null ? "" : libraryDetails.password);
                        libraryInfo = {
                            libraryId: libraryDetails.libraryId,
                            libraryVersion: libraryDetails.libraryVersion,
                            encryptedPassword: encryptedPassword,
                            functionTypes: libraryDetails.functions,
                        };
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.UnlockLibrary(libraryInfo, withIPProtection)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.deleteEncryptedFunctionType = function (libraryId, libraryVersion, password, modelId, typeId, tags) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefDeletePermission();
                        if (password === "" || password === null) {
                            throw new Error("Password cannot be empty");
                        }
                        if (Helper_1.Helper.isTypeGlobal(tags)) {
                            throw new Error("Cannot delete a global Type");
                        }
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, password);
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.deleteEncryptedFunctionType(libraryId, libraryVersion, encryptedPassword, modelId, typeId)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.renameLibrary = function (libraryId, libraryVersion, password, name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var encryptedPassword, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefDeletePermission();
                        encryptedPassword = DataCrypt_1.DataCrypt.encryptPassword(AbilityService_1.AbilityService.accessToken, password === null ? "" : password);
                        return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.renameLibrary(libraryId, libraryVersion, encryptedPassword, name)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.verifyLibraryExists = function (name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.verifyLibraryExists(name)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    FunctionsLibrary.prototype.getLibraryDetails = function (libraryId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FunctionTypeLibrary_1.FunctionTypeLibrary.getLibraryDetails(libraryId)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: response.status,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return FunctionsLibrary;
}());
exports.FunctionsLibrary = FunctionsLibrary;
//# sourceMappingURL=FunctionsLibrary.js.map